export enum SalaryType {
  HOURLY = "HOURLY",
  MONTHLY = "MONTHLY",
}
